module.exports = __webpack_public_path__ + "media/images/flags/64/Bahrain-1784398715347ca03df132ea204d5cad.png";